import React from 'react'

import chatbot from '../../assets/images/mains/chatbot.svg'
import designer from '../../assets/images/mains/designer.svg'
import sales_engg from '../../assets/images/mains/sales_engg.svg'
import software_engg from '../../assets/images/mains/software_engg.svg'
import product_manager from '../../assets/images/mains/product_manager.svg'
import test_engg from '../../assets/images/mains/test_engg.svg'


const Hiring = () => {
    const profile = {
        AiMl_Engg : {
          icon: chatbot,
          title: "AI/ML Engineer",
          desc: "Your work is at the core of everything we build to power our Causal AI engine.",
          cls: "working-item-left",
          bg: "#ebfbff",
          sno: 1,
          snoColor: "#6C63FF"
        },
        Product_Designer : {
          icon: designer,
          title: "Product Designer",
          desc: "Build the most efficient, and easy to use products that delight the customers.",
          cls: "working-item-right",
          bg: "#ebfbff",
          sno: 2,
          snoColor: "#FF0909"
        },
        Sales_Engg : {
          icon: sales_engg,
          title: "Sales Engineer",
          desc: "Be a trusted technical advisor to customers as you guide them through their journey.",
          cls: "working-item-left",
          bg: "#ebfbff",
          sno: 3,
          snoColor: "#FDD402"
        },
        Software_Engg : {
          icon: software_engg,
          title: "Software Engineer",
          desc: "Build the platform with a powerful backend to scale efficiently.",
          cls: "working-item-right",
          bg: "#ebfbff",
          sno: 4,
          snoColor: "#B620E0"
        },
        Product_Manager : {
          icon: product_manager,
          title: "Product Manager",
          desc: "Build the platform with a powerful backend to scale efficiently.",
          cls: "working-item-left",
          bg: "#ebfbff",
          sno: 5,
          snoColor: "#6C63FF"
        },
        Test_Engg : {
          icon: test_engg,
          title: "Test Engineer",
          desc: "Develop environments and infrastructure for testing the complex software systems deployed across a global customer base.",
          cls: "working-item-right",
          bg: "#ebfbff",
          sno: 6,
          snoColor: "#FF0909"
        },
    }
    
  return (
    <div id='hiring'>
      <div className='contianer worldClass my-5 pb-5 pb-sm-3'>
        <div className='worldClass-content'>
          <h2 className='newsLatest-title text-center'>We're growing and hiring</h2>
          <p className='text-center'>Join our team of leading AI/ML engineers and product leaders. Build the cutting edge <br/>AI/ML products that help customers in making business decisions.</p>
        </div>
        <div className='flex-col work-steps w-100'>
          <WorkItem 
            icon={profile.AiMl_Engg.icon} 
            bg={profile.AiMl_Engg.bg} 
            cls={profile.AiMl_Engg.cls} 
            title={profile.AiMl_Engg.title} 
            desc={profile.AiMl_Engg.desc}
            sno={profile.AiMl_Engg.sno}
            snoColor={profile.AiMl_Engg.snoColor}
          />
          <WorkItem 
            icon={profile.Product_Designer.icon} 
            bg={profile.Product_Designer.bg} 
            cls={profile.Product_Designer.cls} 
            title={profile.Product_Designer.title} 
            desc={profile.Product_Designer.desc}
            sno={profile.Product_Designer.sno}
            snoColor={profile.Product_Designer.snoColor}
          />
          <WorkItem 
            icon={profile.Sales_Engg.icon} 
            bg={profile.Sales_Engg.bg} 
            cls={profile.Sales_Engg.cls} 
            title={profile.Sales_Engg.title} 
            desc={profile.Sales_Engg.desc}
            sno={profile.Sales_Engg.sno}
            snoColor={profile.Sales_Engg.snoColor}
          />
          <WorkItem 
            icon={profile.Software_Engg.icon} 
            bg={profile.Software_Engg.bg} 
            cls={profile.Software_Engg.cls} 
            title={profile.Software_Engg.title} 
            desc={profile.Software_Engg.desc}
            sno={profile.Software_Engg.sno}
            snoColor={profile.Software_Engg.snoColor}
          />
          <WorkItem 
            icon={profile.Product_Manager.icon} 
            bg={profile.Product_Manager.bg} 
            cls={profile.Product_Manager.cls} 
            title={profile.Product_Manager.title} 
            desc={profile.Product_Manager.desc}
            sno={profile.Product_Manager.sno}
            snoColor={profile.Product_Manager.snoColor}
          />
          <WorkItem 
            icon={profile.Test_Engg.icon} 
            bg={profile.Test_Engg.bg} 
            cls={profile.Test_Engg.cls} 
            title={profile.Test_Engg.title} 
            desc={profile.Test_Engg.desc}
            sno={profile.Test_Engg.sno}
            snoColor={profile.Test_Engg.snoColor}
          />
            <div className="my-5 text-center">
              <a className="startTrial-button" href="mailto:hi@causalfunnel.com?&subject=Applying for CausalFunnel Openings&body=Hello, I would like to join the CausalFunnel team.  /Attach your resume/"> {"   "}Apply{"   "}</a>
            </div>
        </div>
          </div> 
    </div>
  )
}

export default Hiring


export const WorkItem = (props) => {
    const { icon, bg, cls, title, desc, sno, snoColor} = props;
    return (
        <div className={`${cls} work-item my-2 my-sm-3`} style={{backgroundColor:bg}} x-intersect="$el.classList.add('scale-parallax')">
          <div className='work-content'>
            <h3 className='work-title'>{title}</h3>
            <p className='work-desc'>{desc}</p>
          </div>
          <div className='work-icon-container'>
            <img className='img img-fluid work-icon' src={icon} alt=""/>
          </div>
        </div>
    )
}